
import { Button } from '@/components/ui/button';
import { Folder, Trash2 } from 'lucide-react';

interface Playlist {
  id: string;
  name: string;
  user_id: string;
  created_at: string;
}

interface PlaylistSelectorProps {
  playlists: Playlist[];
  selectedPlaylist: string | null;
  playlistVideos: {[key: string]: string[]};
  onSelectPlaylist: (id: string) => void;
  onDeletePlaylist: (id: string) => void;
}

const PlaylistSelector = ({ 
  playlists, 
  selectedPlaylist, 
  playlistVideos, 
  onSelectPlaylist, 
  onDeletePlaylist 
}: PlaylistSelectorProps) => {
  return (
    <div className="flex flex-wrap gap-2">
      {playlists.map((playlist) => (
        <div key={playlist.id} className="relative group">
          <Button 
            variant={selectedPlaylist === playlist.id ? "default" : "outline"}
            className="flex items-center gap-2"
            onClick={() => onSelectPlaylist(playlist.id)}
          >
            <Folder size={16} />
            {playlist.name}
            <span className="text-xs text-gray-500 dark:text-gray-400">
              ({(playlistVideos[playlist.id] || []).length})
            </span>
          </Button>
          <Button
            variant="ghost"
            size="sm"
            className="absolute -top-2 -right-2 opacity-0 group-hover:opacity-100 transition-opacity rounded-full p-1 h-auto"
            onClick={() => onDeletePlaylist(playlist.id)}
          >
            <Trash2 size={14} />
          </Button>
        </div>
      ))}
    </div>
  );
};

export default PlaylistSelector;
